import React from 'react';
import { ListSubheader, Paper } from '@mui/material';
import { DataState, isDataLoaded } from '../../types';
import { DataIndicators } from '../DataIndicators';
import { useQmaxGraphDetail } from '../../data/DataProviders/QmaxGraphDataProvider';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { ReusableTrendsGraph } from '../ReusableTrendsGraph';
import { INStrendData } from '../../types/device';
export const QmaxGraph: React.FC<{
    monthValue: number;
    qMaxviewFullTrend?: boolean;
    popUpEvent?: any;
    alarmNotifyContent?: any;
    navigationRoute?: any;
}> = (props) => {
    const [maxQmaxTrend, setmaxQmaxTrend] = React.useState<INStrendData>({ state: DataState.Loading });
    const classes = chartLabelNameStyle();
    const maxQmaxResponseData = useQmaxGraphDetail();
    const isEmpty = isDataLoaded(maxQmaxResponseData) ? maxQmaxResponseData.value.channelsData.length === 0 : false;
   
    const qmaxLabelName =
        props.monthValue === 0 ? '3 month daily maximum QMax (mV)' : '12 month daily maximum QMax (mV)';
    const tickInterval = props.monthValue === 0 ? 336 * 3600 * 1000 : 744 * 3600 * 1000;
 
    const qmaxData: any = [];
    React.useEffect(() => {
        if (isDataLoaded(maxQmaxResponseData)) {

            const deviceId = isDataLoaded(maxQmaxResponseData) ? maxQmaxResponseData.value.deviceId : '';
            const deviceName = isDataLoaded(maxQmaxResponseData) ? maxQmaxResponseData.value.deviceName : '';
            maxQmaxResponseData.value.channelsData.map((item) => {
                const maxQmaxAlarmObj = {
                    id: item.channelNumber,
                    deviceId: deviceId,
                    deviceName: deviceName,
                    channelName: item.channelName,
                    value: item.qmaxChartData.map((val) => ({
                        dateTime: new Date(`${val.dateTime}`).toISOString(),
                        value: val.maxQmax,
                        isNewAlarm: val.isNewAlarm,
                        alarmCount: val.alarmCount
                    })),
                    unit: '',
                };

                const qmaxAlarmPointObj = {
                    id: item.channelNumber,
                    deviceId: deviceId,
                    deviceName: deviceName,
                    channelName: `${item.channelName} - Alarm Point`,
                    value: item.qmaxChartData.map((val) => ({
                        dateTime: new Date(`${val.dateTime}`).toISOString(),
                        value: val.alarmPoint,
                    })),
                    unit: '',
                };

                qmaxData.push(maxQmaxAlarmObj);
                qmaxData.push(qmaxAlarmPointObj);
            });

            setmaxQmaxTrend({
                state: DataState.Loaded,
                value: qmaxData,
            });
        }
    }, [maxQmaxResponseData]);

    const openPDIQmaxDialogBox = (): void => {
        props.popUpEvent(true);
    };

    
   /* eslint-disable */
    const downloadCSV = (): void => {};
    return (
        <div data-testid="device-info-maxQmax">
            <Paper style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={maxQmaxResponseData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>
            {isDataLoaded(maxQmaxResponseData) && (
                <>
                    {maxQmaxResponseData.value.channelsData.length > 0 && (
                        <Paper>
                            <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                    {qmaxLabelName}                                  
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon} onClick={openPDIQmaxDialogBox} />}
                                    </span>
                                </ListSubheader>
                                {props.alarmNotifyContent}
                            </div>

                            <ReusableTrendsGraph
                                large
                                trendsData={maxQmaxTrend}
                                downloadCSV={downloadCSV}
                                Inactive={true}
                                tickInterval={tickInterval}
                            
                            />
                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
